module.exports = __webpack_public_path__ + "static/media/react1-package.a464644e.png";